import React, { useEffect, useState } from 'react';
import ReactAntTreeSelect from '@jswork/react-ant-tree-select';
import useMounted from '@jswork/use-mounted';
import { TreeSelect } from 'antd';
import { observer } from 'mobx-react';

const KEY_MAPPING = {
  courseCatalogueResponses: 'children',
  name: 'label',
  title: 'label',
  uuid: 'value',
};

export default observer(props => {
  const isMounted = useMounted();
  const [units, setUnits] = useState([]);
  const courseUuid = nx.get(nx.$root, 'catalog.current.uuid');

  useEffect(() => {
    const { subject } = alo7Nav;
    if (!courseUuid) return;
    nx.$api.business_for_content_repository_list({ subject, courseUuid }).then(res => {
      if (!isMounted) return null;
      const _units = nx.keyMap(res.courseCatalogueResponses, KEY_MAPPING);
      setUnits(_units);
    });
  }, [isMounted, courseUuid]);

  return (
    <ReactAntTreeSelect
      template={({ item }, cb) => {
        const { value, label } = item;
        return (
          <TreeSelect.TreeNode
            disabled={item.children}
            key={value}
            value={value}
            title={label}
            children={cb()}
          />
        );
      }}
      items={units}
      {...props}
      disabled={!units.length}
    />
  );
});
